import {CSSProperties} from 'react';
import styles from './Spinner.module.css';

interface SpinnerI {
  width?: number;
  height?: number;
  inverted?: boolean;
}

export const Spinner = ({width, height, inverted = false}: SpinnerI) => {
  const size = width ?? height ?? 44;

  const className = inverted
    ? `${styles.loader} ${styles.loaderInverted}`
    : styles.loader;

  return (
    <div
      className={className}
      style={{'--loader-size': `${size}px`} as CSSProperties}
      role="status"
      aria-label="Loading"
    />
  );
};
